
export class AlpataMail {
    DosyaAdi: string;
    DosyaBase64: string;
    Telefon: string;
    Email: string;
    Soyad: string;
    Ad: string;
    Mesaj:string;
    SirketTipi:any;
    MailTipi:any;
    ResponseKey:string;
  }
  